import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import OfficialCommonBtn from '../atoms/officialCommonBtn'
import useRouteParam from '../../hooks/useRouteParam'

const Wrapper = styled.article`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  text-align: center;
  margin-bottom: 60px;
  border-radius: 5px;
  padding: 10px;
  height: 200px;
  overflow: hidden;
  background-image: url(/images/column/common/introductionLowerBack.png);
  position: relative;

  p {
    line-height: unset;
    padding: 0px;
  }

  .intro-txt {
    font-size: 18px;
    line-height: 27px;
    color: #fff;
    font-weight: 600;
    padding: 0px;
  }

  .btn-wrap {
    width: 100%;
  }

  .intro-img {
    position: absolute;
    bottom: 12px;
    right: 10px;

    img {
      padding: 0;
      height: 100px;
    }
  }

  Button.mega {
    font-size: 26px;
    height: 60px;
    margin-top: 10px;
  }

  .p-cta-btns {
    margin-bottom: 0;

    button {
      margin-bottom: 0;
      height: 40px;
    }
  }

  ${BreakPoints.large} {
  }
`

/**
 * コラム記事詳細下部製品誘導エリア1(CA)
 * @constructor
 */
const Conclusion007 = () => {
  const routeParam1 = useRouteParam(
    'https://sign-up.kintaicloud.jp/sign-up/?utm_source=article&utm_medium=post&utm_campaign=pattern_07_Con'
  )
  const routeParam2 = useRouteParam(
    'https://www.kintaicloud.jp/download/?utm_source=article&utm_medium=post&utm_campaign=pattern_07_Con'
  )
  const routeParam3 = useRouteParam(
    'https://www.kintaicloud.jp/contact/?utm_source=article&utm_medium=post&utm_campaign=pattern_07_Con'
  )

  return (
    <Wrapper>
      <p className="intro-txt">
        シフトがバラバラで管理が大変…
        <br />
        キンクラなら簡単に自由度の高いシフト作成ができます
      </p>
      <div className="intro-img">
        <img
          src="/images/column/common/introductionLower002.png"
          alt="キンクラ"
        />
      </div>
      <div className="btn-wrap">
        <OfficialCommonBtn
          size="mega"
          level="strong"
          onClick={() => window.open(routeParam1)}
          className="strong-btn"
        >
          無料トライアルはこちら
        </OfficialCommonBtn>
        <div className="p-cta-btns">
          <OfficialCommonBtn
            size="large"
            onClick={() => window.open(routeParam2)}
          >
            資料ダウンロード
          </OfficialCommonBtn>
          <OfficialCommonBtn
            size="large"
            onClick={() => window.open(routeParam3)}
          >
            お問い合わせ
          </OfficialCommonBtn>
        </div>
      </div>
    </Wrapper>
  )
}
export default Conclusion007
